import { isVue2, Transition, defineComponent, ref } from "vue-demi";
import { createVNode, createTextVNode, resolveComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, withCtx, pushScopeId, popScopeId } from "vue";
var index = "";
const components = {};
if (!isVue2)
  components.Transition = Transition;
var Counter = defineComponent({
  name: "Counter",
  components,
  setup(props, context) {
    const count = ref(0);
    const a = ref("jjjjj");
    return {
      a,
      count
    };
  },
  render() {
    var _a, _b, _c, _d;
    const add = () => this.count += 1;
    return createVNode("div", null, [createVNode("button", {
      "type": "button",
      "onClick": add
    }, [createTextVNode("count is: "), this.count]), isVue2 ? this.$slots.default : (_b = (_a = this.$slots).default) == null ? void 0 : _b.call(_a), isVue2 ? this.$scopedSlots.scopedTest({
      data: "Scoped data"
    }) : (_d = (_c = this.$slots).scopedTest) == null ? void 0 : _d.call(_c, {
      data: "Scoped data"
    }), createVNode(resolveComponent("transition"), {
      "name": "fade"
    }, {
      default: () => [this.count > 0 ? createVNode("div", null, [createTextVNode("Transition")]) : null]
    })]);
  }
});
var HelloWorld_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = defineComponent({
  name: "HelloWorld",
  components: {
    Counter
  },
  props: {
    msg: {
      type: String,
      default: "Hello World"
    }
  },
  setup(props, context) {
    const count = ref(0);
    return {
      count
    };
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-f134bc04"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("p", null, [
  /* @__PURE__ */ createTextVNode(" Recommended IDE setup: "),
  /* @__PURE__ */ createElementVNode("a", {
    href: "https://code.visualstudio.com/",
    target: "_blank"
  }, "VSCode"),
  /* @__PURE__ */ createTextVNode(" + "),
  /* @__PURE__ */ createElementVNode("a", {
    href: "https://github.com/johnsoncodehk/volar",
    target: "_blank"
  }, "Volar")
], -1));
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("p", null, [
  /* @__PURE__ */ createTextVNode("See "),
  /* @__PURE__ */ createElementVNode("code", null, "README.md"),
  /* @__PURE__ */ createTextVNode(" for more information.")
], -1));
const _hoisted_3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("p", null, [
  /* @__PURE__ */ createElementVNode("a", {
    href: "https://vitejs.dev/guide/features.html",
    target: "_blank"
  }, " Vite Docs "),
  /* @__PURE__ */ createTextVNode(" | "),
  /* @__PURE__ */ createElementVNode("a", {
    href: "https://v3.vuejs.org/",
    target: "_blank"
  }, "Vue 3 Docs")
], -1));
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", null, "Default slot", -1));
const _hoisted_5 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("p", null, [
  /* @__PURE__ */ createTextVNode(" Edit "),
  /* @__PURE__ */ createElementVNode("code", null, "components/HelloWorld.vue"),
  /* @__PURE__ */ createTextVNode(" to test hot module replacement. ")
], -1));
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Counter = resolveComponent("Counter");
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("h1", null, toDisplayString(_ctx.msg), 1),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    createVNode(_component_Counter, null, {
      default: withCtx(() => [
        _hoisted_4
      ]),
      scopedTest: withCtx(({
        data
      }) => [
        createElementVNode("div", null, toDisplayString(data), 1)
      ]),
      _: 1
    }),
    _hoisted_5
  ]);
}
var HelloWorld = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-f134bc04"]]);
export { HelloWorld as default };
